var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tab-bar-item",style:(_vm.changeStyle),on:{"click":_vm.itemClick,"mouseover":_vm.itemHover,"mouseout":_vm.removeHover}},[_vm._t("item-text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }